import React from "react";
import Header from "../../components/header";
import "./style.css";

const plans = [
  {
    id: "monthly",
    name: "1 Month Plan",
    // duration: "30 days",
    originalPrice: 100,
    // badge: "Starter",
    features: [
      "Publish posts, reels, and stories with smart draft saving",
      "Connect via chat and instant notifications",
      "Customize profile theme, bio links, and privacy controls",
    ],
  },
  {
    id: "half-yearly",
    name: "6 Months Plan",
    // duration: "180 days",
    originalPrice: 600,
    badge: "Current Plan",
    featured: true,
    features: [
      "Everything in 1 Month plan",
      "Schedule content with best-time posting suggestions",
      "Boost reach with featured placement in feeds and communities",
    ],
  },
  {
    id: "yearly",
    name: "1 Year Plan",
    // duration: "365 days",
    originalPrice: 1200,
    // badge: "Best Value",
    features: [
      "Everything in 6 Months plan",
      "Marketplace seller tools with promoted listing support",
      "Priority support and early access to upcoming premium tools",
    ],
  },
];

export default function Pricing() {
  return (
    <div className="pricing_page">
      <Header />

      <main className="pricing_container">
        <section className="pricing_hero">
          {/* <p className="pricing_kicker">USMAAPP PRICING POLICY</p> */}
          <h1>Grow Faster With Our Special Launch Plans</h1>
          <p className="pricing_subtitle">
            Choose your preferred plan and enjoy the full UsmaApp experience
          </p>

          <div className="launch_offer_banner" role="status" aria-live="polite">
            <span className="launch_offer_tag">Launching Offer</span>
            <div className="launch_offer_text_wrap">
              <h2>Launch Special: 100% OFF</h2>
              <p>
                Limited-time offer for all users
              </p>
            </div>
          </div>
        </section>

        <section className="pricing_grid" aria-label="Pricing plans">
          {plans.map((plan) => (
            <article
              key={plan.id}
              className={`pricing_card ${plan.featured ? "featured" : ""}`}
            >
              <div className="pricing_card_badge">{plan.badge}</div>
              <h3>{plan.name}</h3>
              <p className="pricing_duration">{plan.duration}</p>

              <div className="pricing_amount_block">
                <p className="pricing_original"> Rs {plan.originalPrice}</p>
                <p className="pricing_now"> Rs 0</p>
              </div>

              <ul className="pricing_features">
                {plan.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>

              <button
                type="button"
                className={`pricing_active_now ${plan.id !== "half-yearly" ? "pricing_active_now_blur" : ""}`}
                disabled={plan.id !== "half-yearly"}
              >
                Activate Offer
              </button>
            </article>
          ))}
        </section>

        {/* <section className="pricing_note">
          <h4>Pricing Policy Note</h4>
          <p>
            Standard pricing is Rs 100 per month. 6 months is Rs 600 and 1 year is Rs 1200.
            Due to our launch campaign, we are currently offering a <strong>100% discount</strong> to everyone.
          </p>
        </section> */}
      </main>
    </div>
  );
}
